module.exports = __webpack_public_path__ + "img/sv17.9e407d05.svg";